import BaseApi from './baseApi';
import IUser from '../models/IUser';
import IPerson from '../models/IPerson';
import IAuthentication from '../models/IAuthentication';
export default class UserApi extends BaseApi {
    constructor() {
        super("Users", "Users");
    }

    async CreateUser(user: IUser) : Promise<string> {
        const json = this.getJsonSave(user);
        const response = await this.api.post('CreateUser', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateUser(user: IUser) : Promise<boolean> {
        const json = this.getJsonUpdate(user);
        const response = await this.api.post('UpdateUser', json);
        return this.isSuccess(response);
    }

    async DeleteUser(userName: string) : Promise<boolean> {
        const json = this.getJsonDelete(userName);
        const response = await this.api.post('DeleteUser', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(userName : string) : any {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        const json = {
            "user": {
                "Username": userName
            },
            "userCaller": {
                "Id": userFromStorage.idPerson
            }
        };
        return json;
    }

    private getJsonSave(user: IUser) : any {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        const json = {
            "user": {
                "Username": user.userName,
                "IdRole": user.idRole
            },
            "userCaller": {
                "Id": userFromStorage.idPerson
            },
            "password": user.password
        };
        return json;
    }

    private getJsonUpdate(user: IUser) : any {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        const json = {
            "user": {
                "Id": user.id,
                "Username": user.userName,
                "IdRole": user.idRole
            },
            "userCaller": {
                "Id": userFromStorage.idPerson
            },
            "password": user.password
        };
        return json;
    }
}
